import { IconBrandsFacebook } from '@doltech/icons/IconBrandsFacebook';
import { IconSystemV2BlogPronunciation } from '@doltech/icons/SystemV2/IconSystemV2BlogPronunciation';
import { IconSystemV2CourseTestVocabulary } from '@doltech/icons/SystemV2/IconSystemV2CourseTestVocabulary';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';
import { ButtonIconBlockSize } from '@doltech/ui/lib/figma/Button/ButtonIconBlockSize/ButtonIconBlockSize';
import { ButtonIconBlockStyles } from '@doltech/ui/lib/figma/Button/ButtonIconBlockStyles/ButtonIconBlockStyles';
import { ButtonIconSecondary } from '@doltech/ui/lib/figma/Button/ButtonIconSecondary/ButtonIconSecondary';
import { DotDivider } from '@doltech/ui/lib/figma/Divider/DotDivider';
import { DolLogoIeltsSatJuniorDictationTuHoc } from '@doltech/ui/lib/figma/DolLogo/DolLogoIeltsSatJunior';
import { DolFacebookShareButton } from '@doltech/ui/lib/figma/Social/DolFacebookShareButton';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { flexGap } from '@doltech/utils/lib/css-style';
import * as React from 'react';
import styled from 'styled-components';
import { DICTATION_LIST_TOGGLE_ID } from '../../../shared/constant';
import { ButtonIconDictationQuestionList } from '../ButtonIconDictationQuestionList/ButtonIconDictationQuestionList';
import { ButtonMoreActions } from '../../../shared/ui/ButtonMoreActions/ButtonMoreActions';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Main = styled.div`
  background: ${colorsV2.white100};
  border-bottom: 1px solid ${colorsV2.gray20};
  box-shadow: ${shadows.zIndex2};
`;

const Content = styled.div`
  padding: 8px;
  display: flex;
  justify-content: space-between;
  ${flexGap(16)}
  ${fromScreen(400)} {
    padding: 10px 24px;
  }
`;

const TestDetail = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  .total-question {
    white-space: pre-wrap;
    text-overflow: ellipsis;
    word-break: break-all;
  }
`;

const BlockInfo = styled.div``;

const LeftArea = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(16)}
`;

const RightArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  ${flexGap(12)}
`;

interface NavbarLandingProps {
  title: string;
  type: string;
  totalQuestions: number;
  seoUrl: string;
  pageId: string;
  onClose: () => void;
  onToggleQuestionList: () => void;
  onShadowing: () => void;
  onLearnVocab: () => void;
}

export const NavbarLandingMobile = (props: NavbarLandingProps) => {
  const {
    onClose,
    onToggleQuestionList,
    onShadowing,
    onLearnVocab,
    title,
    type,
    totalQuestions,
    seoUrl,
    pageId,
  } = props;

  return (
    <Main className="navbar-dictation-mobile">
      <Content>
        <LeftArea>
          <ButtonIconBlockStyles
            color="neutral"
            buttonStyle="outline"
            backgroundStyle="gray"
            colorStyle="matte"
            content={
              <ButtonIconBlockSize
                size={'x-large'}
                icon={<IconSystemV2EssentialClose size={24} color="neutralPrimary" />}
              />
            }
            onClick={onClose}
          />
          <DolLogoIeltsSatJuniorDictationTuHoc hasDivider />
          <BlockInfo>
            <ResponsiveTypography.Paragraph
              className="progress-number"
              variant="semi-bold/16-24"
              color="black100"
              ellipsis={{ tooltip: true }}
            >
              {title}
            </ResponsiveTypography.Paragraph>
            <TestDetail>
              <ResponsiveTypography.Paragraph
                className="set-name"
                variant="medium/14-20"
                color="black60"
              >
                {type}
              </ResponsiveTypography.Paragraph>
              <DotDivider dotSize={3} space={6} background={colorsV2.black20} />
              <ResponsiveTypography.Paragraph
                className="set-name total-question"
                variant="medium/14-20"
                color="black60"
                ellipsis={{ tooltip: true }}
              >
                {totalQuestions} câu
              </ResponsiveTypography.Paragraph>
            </TestDetail>
          </BlockInfo>
        </LeftArea>

        <RightArea>
          <DolFacebookShareButton
            pageId={pageId}
            className="social-button"
            key="facebook-share"
            url={seoUrl}
          >
            <ButtonIconSecondary
              className="button-icon"
              buttonStyle="gray1"
              size="medium"
              icon={<IconBrandsFacebook color="black80" />}
            />
          </DolFacebookShareButton>

          <ButtonIconDictationQuestionList
            htmlId={DICTATION_LIST_TOGGLE_ID}
            className="action-question-list"
            onClick={onToggleQuestionList}
          />
          <ButtonMoreActions
            className="dropdown-more-action"
            actions={[
              {
                key: 'SHADOWING',
                text: 'Shadowing',
                icon: <IconSystemV2BlogPronunciation size={18} color="neutral180" />,
                onClick: onShadowing,
              },
              {
                key: 'VOCAB',
                text: 'Từ vựng',
                icon: <IconSystemV2CourseTestVocabulary size={18} color="neutral180" />,
                onClick: onLearnVocab,
              },
            ]}
          />
        </RightArea>
      </Content>
    </Main>
  );
};
